import SelectorInput from "./SelectorInput";

export default SelectorInput;
